import React from "react"

const Container = ({ children }) => (
  <main className="flex-1 overflow-y-auto focus:outline-none">{children}</main>
)

export default Container
